// LocalStorage utility for offline mode
const STORAGE_KEYS = {
  ACCOUNTS: 'financeTracker_accounts',
  MONTHLY_DATA: 'financeTracker_monthlyData',
  STORAGE_MODE: 'financeTracker_storageMode',
  OFFLINE_USER: 'financeTracker_offlineUser'
};

// Get offline user data
export const getOfflineUser = () => {
  try {
    const userData = localStorage.getItem(STORAGE_KEYS.OFFLINE_USER);
    if (userData) {
      return JSON.parse(userData);
    }
    // Create default offline user
    const defaultUser = {
      uid: 'offline-user',
      email: 'offline@local',
      displayName: 'Offline User',
      isOffline: true
    };
    setOfflineUser(defaultUser);
    return defaultUser;
  } catch (error) {
    console.error('Error getting offline user:', error);
    return null;
  }
};

// Set offline user data
export const setOfflineUser = (userData) => {
  try {
    localStorage.setItem(STORAGE_KEYS.OFFLINE_USER, JSON.stringify(userData));
  } catch (error) {
    console.error('Error setting offline user:', error);
  }
};

// Get accounts from localStorage
export const getAccountsFromLocalStorage = () => {
  try {
    const accounts = localStorage.getItem(STORAGE_KEYS.ACCOUNTS);
    return accounts ? JSON.parse(accounts) : { assets: [], debts: [] };
  } catch (error) {
    console.error('Error loading accounts from localStorage:', error);
    return { assets: [], debts: [] };
  }
};

// Save accounts to localStorage
export const saveAccountsToLocalStorage = (accounts) => {
  try {
    localStorage.setItem(STORAGE_KEYS.ACCOUNTS, JSON.stringify(accounts));
  } catch (error) {
    console.error('Error saving accounts to localStorage:', error);
    throw error;
  }
};

// Get monthly data from localStorage
export const getMonthlyDataFromLocalStorage = () => {
  try {
    const data = localStorage.getItem(STORAGE_KEYS.MONTHLY_DATA);
    return data ? JSON.parse(data) : [];
  } catch (error) {
    console.error('Error loading monthly data from localStorage:', error);
    return [];
  }
};

// Save monthly data to localStorage
export const saveMonthlyDataToLocalStorage = (monthlyData) => {
  try {
    localStorage.setItem(STORAGE_KEYS.MONTHLY_DATA, JSON.stringify(monthlyData));
  } catch (error) {
    console.error('Error saving monthly data to localStorage:', error);
    throw error;
  }
};

// Get storage mode preference
export const getStorageMode = () => {
  try {
    return localStorage.getItem(STORAGE_KEYS.STORAGE_MODE) || null;
  } catch (error) {
    console.error('Error getting storage mode:', error);
    return null;
  }
};

// Set storage mode preference
export const setStorageMode = (mode) => {
  try {
    localStorage.setItem(STORAGE_KEYS.STORAGE_MODE, mode);
  } catch (error) {
    console.error('Error setting storage mode:', error);
  }
};

// Clear offline data (for migration)
export const clearOfflineData = () => {
  try {
    localStorage.removeItem(STORAGE_KEYS.ACCOUNTS);
    localStorage.removeItem(STORAGE_KEYS.MONTHLY_DATA);
    localStorage.removeItem(STORAGE_KEYS.OFFLINE_USER);
    localStorage.removeItem(STORAGE_KEYS.STORAGE_MODE);
  } catch (error) {
    console.error('Error clearing offline data:', error);
  }
};

// Get all offline data (for migration)
export const getAllOfflineData = () => {
  try {
    return {
      accounts: getAccountsFromLocalStorage(),
      monthlyData: getMonthlyDataFromLocalStorage()
    };
  } catch (error) {
    console.error('Error getting all offline data:', error);
    return {
      accounts: { assets: [], debts: [] },
      monthlyData: []
    };
  }
};

// Check if offline data exists
export const hasOfflineData = () => {
  const accounts = getAccountsFromLocalStorage();
  const monthlyData = getMonthlyDataFromLocalStorage();
  return accounts.assets.length > 0 || accounts.debts.length > 0 || monthlyData.length > 0;
};
